import { useEffect, useState } from "react";
import MDBox from "../../MDs/MDBox";
import "../graphImg.css";

function ImgRefresh({ graphData, timeUpdated, noRefresh, isPng }) {
  const {
    ip,
    item,
    period,
    src
  } = graphData;
  const [firstLoad, setFirsLoad] = useState(true);
  const [cachedImageUrl, setCachedImageUrl] = useState("");

  useEffect(() => {
    const image = new Image();
    const source = `${src}${!noRefresh ? `&${timeUpdated.valueOf()}` : ""}${isPng ? ".png" : ""}`;

    image.onload = () => {
      setCachedImageUrl(source);
      if (firstLoad) {
        setFirsLoad(false);
      }
    }

    image.src = source;

    return () => {
      image.onload = ()=>{}
    }
  }, [timeUpdated]);

  return (
     <MDBox
        mt={0.5}
        py={1}
        sx={{ textAlign: 'center', minHeight: { md: '285px', xs: '170px' } }}
     >
       <img
          src={firstLoad
             ? require("./whiteImg.png")
             : cachedImageUrl
          }
          key={`${src}-${ip}-${item}-${period}-${timeUpdated}`}
          alt="graph-img"
          style={{ maxWidth: '100%', maxHeight: '282px' }}
       />
     </MDBox>
  );
}

export default ImgRefresh;
